const SldsDataTable = () => {
    return (
        <table class="slds-table slds-table_cell-buffer slds-table_bordered" aria-labelledby="element-with-table-label other-element-with-table-label">
            <thead>
                <tr class="slds-line-height_reset">
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Opportunity Name">Opportunity Name</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Account Name">Account Name</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Close Date">Close Date</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Stage">Stage</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Confidence">Confidence</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Amount">Amount</div>
                    </th>
                    <th class="" scope="col">
                        <div class="slds-truncate" title="Contact">Contact</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="slds-hint-parent">
                    <th data-label="Opportunity Name" scope="row">
                        <div class="slds-truncate" title="Cloudhub">
                            <a href="#" tabindex="-1">Cloudhub</a>
                        </div>
                    </th>
                    <td data-label="Account Name">
                        <div class="slds-truncate" title="Cloudhub">Cloudhub</div>
                    </td>
                    <td data-label="Close Date">
                        <div class="slds-truncate" title="4/14/2015">4/14/2015</div>
                    </td>
                    <td data-label="Prospecting">
                        <div class="slds-truncate" title="Prospecting">Prospecting</div>
                    </td>
                    <td data-label="Confidence">
                        <div class="slds-truncate" title="20%">20%</div>
                    </td>
                    <td data-label="Amount">
                        <div class="slds-truncate" title="$25k">$25k</div>
                    </td>
                    <td data-label="Contact">
                        <div class="slds-truncate" title="jrogers@cloudhub.com">
                            <a href="#" tabindex="-1">jrogers@cloudhub.com</a>
                        </div>
                    </td>
                </tr>
                <tr class="slds-hint-parent">
                    <th data-label="Opportunity Name" scope="row">
                        <div class="slds-truncate" title="Cloudhub + Anypoint Connectors">
                            <a href="#" tabindex="-1">Cloudhub + Anypoint Connectors</a>
                        </div>
                    </th>
                    <td data-label="Account Name">
                        <div class="slds-truncate" title="Cloudhub">Cloudhub</div>
                    </td>
                    <td data-label="Close Date">
                        <div class="slds-truncate" title="4/14/2015">4/14/2015</div>
                    </td>
                    <td data-label="Prospecting">
                        <div class="slds-truncate" title="Prospecting">Prospecting</div>
                    </td>
                    <td data-label="Confidence">
                        <div class="slds-truncate" title="20%">20%</div>
                    </td>
                    <td data-label="Amount">
                        <div class="slds-truncate" title="$25k">$25k</div>
                    </td>
                    <td data-label="Contact">
                        <div class="slds-truncate" title="jrogers@cloudhub.com">
                            <a href="#" tabindex="-1">jrogers@cloudhub.com</a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default SldsDataTable;